import React from "react";
import { array } from "prop-types";
import { Box } from "@mui/material";

const ComparisonChartLegend = ({ items = null }) => {
  const _items = items || {
    $150K: "#489BE0",
    $100K: "#46BBA0",
    "Your Price": "#484349",
  };

  const rectangle = (color) => (
    <Box
      component="div"
      sx={{
        display: "inline-block",
        width: "10px",
        height: "10px",
        marginLeft: "8px",
        marginRight: "4px",
        backgroundColor: color,
      }}
    />
  );

  const itemElement = (name, i) => (
    <Box key={i} sx={{ alignItems: "center", display: "flex" }}>
      {rectangle(_items[name])} {name}
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        "& > div": {
          display: "inline-block",
          whiteSpace: "nowrap",
          top: "0px",
          left: "13px",
          margin: "4px 34px 0px 7px",
        },
      }}
    >
      {Object.keys(_items).map((name, i) => itemElement(name, i))}
    </Box>
  );
};

ComparisonChartLegend.propTypes = {
  items: array,
};

export default ComparisonChartLegend;
